export enum EstimationMethod {
  NotSpecified = 0,
  SameAsDayBefore = 1,
  SameAsSevenDaysBefore = 2,
  ControlMeter = 3,
  SameAs1MonthBefore = 4,
  GhostMeter = 5,
  ZeroValueMeteringPointDisconnected = 6,
  ZeroValueInsideDay = 7,
  ManualNotSpecified = 8,
  ManualEvenly = 9,
  ManualLastPosition = 10,
  ManualProfile = 11,
  ManualOtherMeteringPoint = 12,
  AdvancedVEE = 13,
  ManualAdvancedVEE = 14,
  AdvancedVEELookBack = 15,
  AdvancedVEEClustering = 16,
  AdvancedVEEEVHandler = 17,
  ZeroValueMeterChange = 18
}
